import { Button, HStack } from '@chakra-ui/react';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { routes } from '../data/routes';
import Emoji from './Emoji';

export const Backer = () => {
  const navigate = useNavigate();

  const onClick = useCallback(() => {
    navigate(routes.root);
  }, [navigate]);

  return (
    <HStack>
      <Button onClick={onClick}>
        <Emoji symbol="👈" label="Quill" spaceRight /> Back to writing desk
      </Button>
    </HStack>
  );
};
